import { render, staticRenderFns } from "./CreateExamination.vue?vue&type=template&id=feac353a&scoped=true&"
import script from "./CreateExamination.vue?vue&type=script&lang=js&"
export * from "./CreateExamination.vue?vue&type=script&lang=js&"
import style0 from "./CreateExamination.vue?vue&type=style&index=0&id=feac353a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feac353a",
  null
  
)

export default component.exports